import React, { useEffect, useRef, useState } from "react";
import { useQuery, useQueryClient } from "react-query";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import api from "../../services/api";

const ENDPOINT_BY_TYPE = {
  corrective: (id) => `/corrective/update-second-tech/${id}`,
  preventive: (id) => `/preventive/update-second-tech/${id}`,
  "preventive-combustion": (id) =>
    `/preventive/update-second-tech-combustion/${id}`
};

const TITLE_BY_TYPE = {
  corrective: "Editar 2º técnico (Corretiva)",
  preventive: "Editar 2º técnico (Preventiva)",
  "preventive-combustion": "Editar 2º técnico (Preventiva Combustão)"
};

const ChangeSecondTech = ({
  visible,
  onHide,
  reportType,
  reportId,
  currentSecondTechId,
  onSuccess
}) => {
  const queryClient = useQueryClient();
  const toast = useRef(null);
  const [selectedTechId, setSelectedTechId] = useState(
    currentSecondTechId ?? null
  );
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setSelectedTechId(currentSecondTechId ?? null);
  }, [currentSecondTechId, visible]);

  const { data: techs = [], isLoading: techsLoading } = useQuery(
    ["techs"],
    () => api.get("/users/getTechs").then((r) => r.data),
    { staleTime: 5 * 60 * 1000, enabled: visible }
  );

  const options = techs.map((t) => ({ label: t.name, value: t.id }));

  const handleSave = async () => {
    if (saving || !reportType || !reportId) return;
    setSaving(true);
    try {
      const url = ENDPOINT_BY_TYPE[reportType](reportId);
      await api.put(url, { second_tech: selectedTechId });
      toast.current?.show({
        severity: "success",
        summary: "",
        detail: "2º técnico atualizado.",
        life: 4000
      });
      if (onSuccess) onSuccess();
      onHide();
    } catch (err) {
      const status = err?.response?.status;
      if (status === 422) {
        toast.current?.show({
          severity: "warn",
          summary: "",
          detail: "Técnico não disponível. Recarregue a lista.",
          life: 5000
        });
        queryClient.invalidateQueries(["techs"]);
      } else {
        toast.current?.show({
          severity: "error",
          summary: "",
          detail: "Não foi possível atualizar o 2º técnico.",
          life: 5000
        });
      }
    } finally {
      setSaving(false);
    }
  };

  const footer = (
    <div>
      <Button
        label="Cancelar"
        className="p-button-text"
        onClick={onHide}
        disabled={saving}
      />
      <Button
        label="Salvar"
        icon="pi pi-check"
        onClick={handleSave}
        loading={saving}
        disabled={techsLoading}
      />
    </div>
  );

  return (
    <>
      <Toast ref={toast} />
      <Dialog
        header={TITLE_BY_TYPE[reportType] || "Editar 2º técnico"}
        visible={visible}
        style={{ width: "420px" }}
        modal
        footer={footer}
        onHide={onHide}
        closable={!saving}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <label
            htmlFor="second-tech-dropdown"
            style={{ fontWeight: 600 }}
          >
            Segundo técnico
          </label>
          <Dropdown
            id="second-tech-dropdown"
            value={selectedTechId}
            options={options}
            onChange={(e) => setSelectedTechId(e.value)}
            placeholder={techsLoading ? "Carregando..." : "Não atribuído"}
            filter
            showClear
            disabled={techsLoading}
          />
        </div>
      </Dialog>
    </>
  );
};

export default ChangeSecondTech;
